import React, { useEffect } from "react";
import SuccessPng from "../../images/success.png";
import FailPng from "../../images/fail.png";
import Cookies from "js-cookie";
import PayInfos from "../../components/payInfos";
import getQueryString from "@/utils/getQueryString";
import { getQuery } from "@/utils/navigator";
import { PAY_ORDER_INFO, title } from "../const";
import "./index.less";

export default function PayResult() {
  const price: number = +getQuery("price") || 0; // 价格
  const orderId: string = getQuery("orderId");
  const account: string = getQuery("account");
  const description: string = getQuery("description");
  const duration: string = getQuery("expired");
  // 跳转到支付中转页后重定向到当前页面所携带的字段
  // 自测后发现返回：成功-ok，取消支付-''(空字符串)
  const wcpayRequestMsg: string = getQueryString("wcpayRequestMsg");

  useEffect(() => {
    document.title = title;
  }, []);

  useEffect(() => {
    if (wcpayRequestMsg === "ok") {
      Cookies.remove(PAY_ORDER_INFO);
    }

    // 如果是取消支付状态，直接重定向回支付页面
    if (wcpayRequestMsg === "") {
      backToPayPage();
    }
  }, []);

  const renderSuccess = () => {
    return (
      <div className="pay-success">
        <div className="success-icon">
          <img className="success-img" src={SuccessPng} alt="支付成功" />
          <p className="success-text">支付成功</p>
        </div>

        <div className="notice-text">会员到账可能有延迟，请耐心等待</div>

        <div className="price-container">
          <span className="price-symbol">￥</span>
          <span className="price-value">{price}</span>
        </div>

        <PayInfos
          orderId={orderId}
          account={account}
          description={description}
          duration={duration}
        />
      </div>
    );
  };

  const renderFail = () => {
    return (
      <div className="pay-fail">
        <div className="desc-container">
          <img className="fail-img" src={FailPng} alt="支付失败" />
          <p className="fail-text">支付失败</p>
          <p className="notice-text">请刷新二维码后，重新扫码支付</p>
        </div>
      </div>
    );
  };

  const backToPayPage = () => {
    const redictUrl = `${location.origin}/payment/pay${location.search}`;
    window.location.replace(redictUrl);
  };

  const renderByWcpayRequestMsg = (type: string) => {
    let html = null;
    switch (type) {
      case "ok":
        html = renderSuccess();
        break;
      case "fail":
        html = renderFail();
        break;
      default:
        break;
    }
    return html;
  };

  return (
    <React.Fragment>{renderByWcpayRequestMsg(wcpayRequestMsg)}</React.Fragment>
  );
}
